module.exports = __webpack_public_path__ + "static/media/signature-small.23eb6096.svg";